import { useCallback } from "react";
import { useModuleVisibilityContext } from "../providers/ModuleVisibilityProvider";

/**
 * Hook centralizzato per la visibilità di moduli/pagine/tab (feature-flag runtime).
 * - isVisible(key)     → moduli sidebar e pagine (flag "fe:<key>")
 * - isTabVisible(key)  → tab interni alle pagine (flag "fe:tab:<key>")
 * - filterTabs(items, getKey) → filtra un array di tab tenendo solo i visibili
 * Flag assente = visibile (opt-out). Catalogo chiavi: module-visibility/seed-default.json.
 */
export const useModuleVisibility = () => {
  const { flags, isLoaded } = useModuleVisibilityContext();

  const isVisible = useCallback(
    (key: string): boolean => flags[`fe:${key}`] !== false,
    [flags]
  );

  const isTabVisible = useCallback(
    (key: string): boolean => flags[`fe:tab:${key}`] !== false,
    [flags]
  );

  const filterTabs = useCallback(
    <T,>(items: T[], getKey: (item: T) => string): T[] =>
      items.filter((item) => flags[`fe:tab:${getKey(item)}`] !== false),
    [flags]
  );

  return { isVisible, isTabVisible, filterTabs, isLoaded };
};
